import { Typography } from '@mui/material'
import { AddressElement, PaymentElement } from '@stripe/react-stripe-js'
import { noop } from 'lodash'
import { ADDRESS_OPTIONS } from './constants'
import { GridContainer, GridItem } from '@wolfdanepug/common-react'

const ShippingAddress = ({ onChange = noop, mode = 'shipping', initialState = {} }: any) => (
	<GridContainer>
		<GridItem>
			<Typography variant="h4">Shipping Address</Typography>
		</GridItem>
		<GridItem>
			<AddressElement
				onChange={onChange}
				options={{
					...ADDRESS_OPTIONS,
					mode,
					defaultValues: initialState
				}}
			/>
		</GridItem>
	</GridContainer>
)

const PaymentMethod = ({ onChange = noop }: any) => (
	<GridContainer>
		<GridItem>
			<Typography variant="h4">Payment Method</Typography>
		</GridItem>
		<GridItem>
			<PaymentElement onChange={onChange} />
		</GridItem>
	</GridContainer>
)

export default function StripePaymentMethodFields({
	record = {},
	onChange = noop,
	addressMode = 'shipping',
	loading = false
}: any) {
	return (
		<>
			<GridItem>
				<ShippingAddress
					onChange={(data: any) => onChange('address', data)}
					initialState={{
						name: record?.name || '',
						phone: record?.phone || '',
						address: record?.address || {}
					}}
					mode={addressMode}
				/>
			</GridItem>
			<GridItem>
				<PaymentMethod onChange={(data: any) => onChange('payment', data)} />
			</GridItem>
		</>
	)
}
